import QueryString from 'query-string';
import { toastr } from 'react-redux-toastr';
import { push } from 'react-router-redux';
import {
FLAG_GETTING_LIQUIDATION_DIFFERENCE_REASONS,
  GET_LIQUIDATION_DIFFERENCE_REASONS,
  CLEAR_LIQUIDATION_DIFFERENCE_REASONS,
  FLAG_GETTING_LIQUIDATION_DIFFERENCE_REASON,
  GET_LIQUIDATION_DIFFERENCE_REASON,
  CLEAR_LIQUIDATION_DIFFERENCE_REASON,
} from '../types';
import { LIQUIDATION_DIFFERENCE_REASON_ENDPOINT } from '../../config/endpoints';
import {
  DEFAULT_DELETE_CONFIG,
  DEFAULT_GET_CONFIG,
  DEFAULT_POST_CONFIG,
  DEFAULT_PUT_CONFIG,
} from '../../config/rest';
import { isErrorResponse } from '../../utils/error-handlers';
import { LIQUIDATION_DIFFERENCE_REASON_PATH } from '../../config/paths';

const flagGettingLiquidationDifferenceReasons = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_LIQUIDATION_DIFFERENCE_REASONS,
    payload: flag,
  });

const getLiquidationDifferenceReasons = async (tableFilters) => async (dispatch) => {
  try {
    dispatch(flagGettingLiquidationDifferenceReasons(true));
    const query = tableFilters;
    const url = `${LIQUIDATION_DIFFERENCE_REASON_ENDPOINT}?${QueryString.stringify(query)}`;
    const response = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(response, null, dispatch);
    const liquidationDifferenceReasons = await response.json();
    dispatch({
      type: GET_LIQUIDATION_DIFFERENCE_REASONS,
      payload: liquidationDifferenceReasons,
    });
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagGettingLiquidationDifferenceReasons(false));
  }
};

const clearLiquidationDifferenceReasons = () => (dispatch) =>
  dispatch({
    type: CLEAR_LIQUIDATION_DIFFERENCE_REASONS,
  });

const flagGettingLiquidationDifferenceReason = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_LIQUIDATION_DIFFERENCE_REASON,
    payload: flag,
  });

const getLiquidationDifferenceReason =
  async ({ liquidationDifferenceReasonId }) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingLiquidationDifferenceReason(true));
      const url = `${LIQUIDATION_DIFFERENCE_REASON_ENDPOINT}/${liquidationDifferenceReasonId}`;
      const response = await fetch(url, { ...DEFAULT_GET_CONFIG });
      await isErrorResponse(response, null, dispatch);
      const liquidationDifferenceReason = await response.json();
      dispatch({
        type: GET_LIQUIDATION_DIFFERENCE_REASON,
        payload: liquidationDifferenceReason,
      });
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagGettingLiquidationDifferenceReason(false));
    }
  };

const clearLiquidationDifferenceReason = () => (dispatch) =>
  dispatch({
    type: CLEAR_LIQUIDATION_DIFFERENCE_REASON,
  });

const postLiquidationDifferenceReason =
  async ({ name, description }) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingLiquidationDifferenceReason(true));
      const payload = {
        name, description
      };
      const url = LIQUIDATION_DIFFERENCE_REASON_ENDPOINT;
      const response = await fetch(url, {
        ...DEFAULT_POST_CONFIG,
        body: JSON.stringify(payload),
      });
      await isErrorResponse(response, null, dispatch);
      const liquidationDifferenceReason = await response.json();
      dispatch(push(`${LIQUIDATION_DIFFERENCE_REASON_PATH}/${liquidationDifferenceReason.id}`));
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagGettingLiquidationDifferenceReason(false));
    }
  };

const putLiquidationDifferenceReason =
  async (liquidationDifferenceReasonId, { name, description }) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingLiquidationDifferenceReason(true));
      const payload = {
        id: liquidationDifferenceReasonId,
        name, description
      };
      const url = `${LIQUIDATION_DIFFERENCE_REASON_ENDPOINT}/${liquidationDifferenceReasonId}`;
      const response = await fetch(url, {
        ...DEFAULT_PUT_CONFIG,
        body: JSON.stringify(payload),
      });
      await isErrorResponse(response, null, dispatch);
      const liquidationDifferenceReason = await response.json();
      dispatch(push(`${LIQUIDATION_DIFFERENCE_REASON_PATH}/${liquidationDifferenceReason.id}`));
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagGettingLiquidationDifferenceReason(false));
    }
  };

const deleteLiquidationDifferenceReason =
  async ({ liquidationDifferenceReasonId }) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingLiquidationDifferenceReason(true));
      const url = `${LIQUIDATION_DIFFERENCE_REASON_ENDPOINT}/${liquidationDifferenceReasonId}`;
      const response = await fetch(url, {
        ...DEFAULT_DELETE_CONFIG,
      });
      await isErrorResponse(response, null, dispatch);
      await response;
      dispatch(push(LIQUIDATION_DIFFERENCE_REASON_PATH));
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagGettingLiquidationDifferenceReason(false));
    }
  };

export {
  getLiquidationDifferenceReasons,
  clearLiquidationDifferenceReasons,
  getLiquidationDifferenceReason,
  postLiquidationDifferenceReason,
  putLiquidationDifferenceReason,
  clearLiquidationDifferenceReason,
  deleteLiquidationDifferenceReason,
};
